import React, { useEffect, useRef, useState } from 'react'
import TopNav, { BottomNav } from '../components/layoucomp/NavComponents';
import robo from '../images/robo.png';
import HowitWorks from '../components/HowitWorks';
import UseCases from '../components/UseCases';
import ContactSales from '../components/ContactSales';
import Mobot from '../components/MobotEngine/Mobot';
import { CToast, CToastBody, CToaster, CToastHeader } from '@coreui/react';
import { Close } from '@mui/icons-material';

export default function Index() {

    const [popUp, setPopUp] = useState(false);
    const [data, setData] = useState('')
    const [toast, addToast] = useState(0)
    const toaster = useRef()
    function saveData() {
        if (data == "") {
            addToast(exampleToast('Empty Data Added', 'Error!'))
        } else {
            localStorage.setItem('dataset', data)
            setPopUp(false)
            addToast(exampleToast('Data set saved you can test the bot now', 'Saved!'))
        }

    }

    function exampleToast(message, title,) {
        return (
            <CToast style={{ '--cui-toast-zindex': 99999999999999999 }}>
                <CToastHeader closeButton>
                    <svg
                        className="rounded me-2"
                        width="20"
                        height="20"
                        xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="xMidYMid slice"
                        focusable="false"
                        role="img"
                    >
                        <rect width="100%" height="100%" fill="#007aff"></rect>
                    </svg>
                    <div className="fw-bold me-auto">{title}</div>
                    {/* <small>7 min ago</small> */}
                </CToastHeader>
                <CToastBody>{message}</CToastBody>
            </CToast>
        )
    }
    return (
        <>{popUp &&
            <div style={{
                backgroundColor: '#00000070',
                height: '100vh',
                width: '100%',
                position: 'fixed',
                zIndex: 9999999999999999,
            }} className="d-flex justify-content-center align-items-center">

                <div className='bg-white col-lg-8 col-12 container-fluid rounded-3 p-3'>
                    <div>
                        <div className="d-flex w-100 justify-content-between">
                            <span className='mb-3'>Enter your data set as text</span>
                            <span onClick={() => { setPopUp(false) }}>
                                <Close />
                            </span>
                        </div>

                        <textarea value={data} onChange={(e) => { setData(e.target.value) }} rows="10" className='form-control mb-3'></textarea>
                    </div>
                    <button onClick={saveData} className='btn btn-primary' >Save</button>
                </div>


            </div>
        }

            <div>
                <CToaster ref={toaster} push={toast} placement="bottom-start" />

                <TopNav />
                <div className='landingBg  row align-items-center justify-content-center p-5'>
                    <div className='p-5'>
                    </div>
                    <div className='col-lg-6 order-2 order-lg-0 text-center'>
                        <h2 className='display-1 landText'>
                            MDBOT
                        </h2>
                        <p className='landText fs-1'>Smart AI chatbot</p>

                        <p className='blueText mb-3'>Our AI chat bot is natural language processed bot, leveraging on big data and extensive research model can be trained to perforom specific chat bot needs for your business!</p>
                        <div>
                            <button style={{
                                backgroundColor: '#081b72',
                                color: 'white',
                            }} onClick={() => { setPopUp(true) }} className='btn btn-lg'>Test with a Demo</button>
                        </div>
                    </div>
                    <div className='col-lg-6  animated-image-container text-center'>
                        <img className='animated-image img-fluid' src={robo} alt="robotDoc" />
                    </div>
                </div>

                <div>
                    <HowitWorks />
                </div>
                <div className='mt-4'>
                    <UseCases />
                </div>

                <div className='mt-4'>
                    <ContactSales />
                </div>
                <div><Mobot /></div>
                <BottomNav />
            </div>
        </>
    )
}
